import styled from '@emotion/styled';
import { theme } from '../../styles';

export const ProjectPageContainer = styled.div`
  .HeadingContainer__TitleSection {
    margin-bottom: 0;
  }

  .Graphics__Container {
    margin-bottom: ${theme.scale('120px')};
  }

  .Projects__Graphics {
    @media (min-width: ${theme.breakpoints.md}) {
      margin-top: -30px;
    }
  }
`;
